<template>
  <!-- 
          :before-upload="beforeAvatarUpload"
          accept="image/jpeg,image/jpg,image/png,application/pdf,application/zip,.zip"
        -->
  <el-row>
    <el-upload
    :class="{
      'avatar-uploader-none': type !== 'new'
    }"
    action=""
    :disabled="type !== 'new'"
    :accept='accept'
    :http-request="httpRequest"
    :before-upload="beforeUpload"
    :file-list="info.invoiceUrl"
    :on-preview="handlePictureCardPreview"
    :on-remove="handleRemove"
    show-file-list
  >
    <el-button size="small" type="primary" :disabled="type !== 'new'">点击上传</el-button>
  </el-upload>
    <el-image-viewer v-if="showImg" :url-list="getImageList" :on-close="colseImg" :zIndex="3000"
      :initialIndex="initialIndex" class="img-viewer-row" />
  </el-row>
</template>
<script>
import { uploadFile, fileDownload } from '@/api/user'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import ReviewProcess from '@/components/ReviewProcess.vue'
import previewDetail from '@/components/Dialog/previewDetail'
export default {
  data() {
    return {
      initialIndex: 0,
      showImg: false,
      info: {
        invoiceUrl: []
      }
    }
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    // 回显或者上传时获取的参数
    modelValue: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Array | Number
    },
    type: {
      default: '',
      type: String
    },
    // 上传类型校验.jpg,.png,.jpeg,.gif,.bmp .rar,.zip,.doc,.docx,.pdf
    accept: {
      type: String,
      default: ''
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        if (val === '') {
          return
        }
        this.info.invoiceUrl = val.split(',').map((item, index) => {
          let name = item.split('/')
          let type = name[2].split('.')[1]
          return {
            fileName: item,
            name: name[name.length - 1],
            url: process.env.VUE_APP_BASE_API + `/minio/getImage?fileName=${item}`,
            code: `invoiceUrl${index}`,
            type: type
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    getImageList() {
      let imageList = this.info.invoiceUrl.filter((item) => {
        return (item.type === 'jpeg' || item.type === 'jpg' || item.type === 'png')
      }).map(v => v.url)
      return imageList
    },
  },
  components: {
    previewDetail,
    ReviewProcess,
    ElImageViewer,
  },
  methods: {
    colseImg() {
      this.showImg = false
    },
    // 文件上传
    async httpRequest(param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      const { code, result, message } = await uploadFile(fd)
      if (code === 0) {
        let name = result.split('/')
        let type = name[2].split('.')[1]
        this.info.invoiceUrl.push({
          fileName: result,
          name: name[name.length - 1],
          url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + result,
          code: result,
          type: type
        })
        this.$emit('change', this.info.invoiceUrl.map(v => v.fileName).join(','))
      } else {
        this.$message.error(message)
      }
    },
    handleRemove(row) {
      this.info.invoiceUrl = this.info.invoiceUrl.filter((item) => item.url !== row.url)
      this.$emit('change', this.info.invoiceUrl.map(v => v.fileName).join(','))
    },
    async handlePictureCardPreview(file) {
      if (this.isTypeImage(file)) {
        this.showImg = true
        this.initialIndex = this.getImageList.indexOf(file.url) > -1 ? this.getImageList.indexOf(file.url) : 0
      } else {
        let componentProps = {
          curStatus: '',
          pdfFile: file
        }
        let dialogProps = {
          title: '文件预览',
          width: '80%',
          footer: true
        }
        if (['pdf', 'PDF'].includes(file.type)) {
          componentProps.curStatus = 'pdf'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        if (['doc', 'docx'].includes(file.type)) {
          componentProps.curStatus = 'doc'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        if (['xlsx', 'xls'].includes(file.type)) {
          componentProps.curStatus = 'xls'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        let res = await fileDownload(file.url.split('=')[1])
        let blob = new Blob([res.data], { type: res.data.type })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = file.name
        link.click()
      }
    },
    beforeUpload (file) {
      if (this.accept === '') {
        return
      }
      let fileTypeList = this.accept.split(',.')
      fileTypeList[0] = fileTypeList[0].slice(1)
      let type = file.name.split('.')
      const isJPG = fileTypeList.includes(type[type.length - 1])
      // const isLt2M = file.size / 1024 / 1024 < this.maxLength
      if (!isJPG) {
        this.$message.error(`上传文件只能是 ${fileTypeList.join('、')} 格式!`)
      }
      // if (!isLt2M) {
      //   this.$message.error(`上传文件大小不能超过${this.maxLength}MB!`)
      // }
      return isJPG
    },
    isTypeImage(item) {
      if (item.type === 'jpeg' || item.type === 'jpg' || item.type === 'png') {
        return true
      }
    }
  }
}
</script>
